import React, { useState, useEffect, useContext } from "react";
import { BrowserRouter as Router, Link } from "react-router-dom";
import { api } from "../../utils/Api";

export default function Activity(props: any) {
  const [active, setActive] = useState([]);
  const [history, SetHistory] = useState(Boolean);

  async function get_Active_Company() {
    //     // }

    let pass_data: any = {
      get: {},
    };

    if (history) {
      console.log("history", history);
      pass_data.get.history = true;
    }
    console.log("pass_data", pass_data);
    let response = await api("/company/get", pass_data);
    console.log("app_init :", response.response.data);

    setActive(response.response.data);
  }

  useEffect(() => {
    console.log("Activity On mount :", props);
    // get_Active_Company();
  }, []);

  useEffect(() => {
    console.log("Activity On mount :", props);
    get_Active_Company();
  }, [history]);

  return (
    <>
      {active ? (
        <>
          <div className="bg-white mb-3 pt-5">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <h5 className="mb-3">Works</h5>
                  <nav className="pt-1 sticky-tabs">
                    <div className="nav nav-tabs " id="nav-tab" role="tablist">
                      <button
                        className="nav-link active"
                        id="active-users-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#active-users"
                        type="button"
                        role="tab"
                        aria-controls="active-users"
                        aria-selected="true"
                        onClick={() => {
                          SetHistory(false);
                        }}
                      >
                        Active
                      </button>
                      <button
                        className="nav-link"
                        id="deleted-users-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#deleted-users"
                        type="button"
                        role="tab"
                        aria-controls="deleted-users"
                        aria-selected="false"
                        onClick={() => {
                          SetHistory(true);
                        }}
                      >
                        History
                      </button>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>

          <div className="tab-content" id="nav-tabContent">
            <div
              className="tab-pane fade show active"
              id="active-users"
              role="tabpanel"
              aria-labelledby="active-users-tab"
            >
              <div className="container">
                <div className="row">
                  {active.map((item, index) => (
                    <div className="col-lg-6 p-2">
                      <Link
                        className="text-decoration-none text-dark text-decoration-color: black"
                        to={"/company/" + item.id}
                      >
                        <div className="card ">
                          <div className="card-body">
                            <h5 className="card-title mb-3">{item.name}</h5>
                            <div className="d-flex">
                              <div>
                                <h6 className="card-subtitle text-muted">
                                  {item.app}
                                </h6>
                              </div>

                              <div className="col card-text">
                                <div className="ms-auto text-end">
                                  {item.status == "Rejected" && (
                                    <span className="badge bg-danger">
                                      Rejected
                                    </span>
                                  )}

                                  {item.status == "Deleted" && (
                                    <span className="badge bg-danger">
                                      Deleted
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <h5>No companies to show</h5>
      )}
    </>
  );
}
